// Packages
import React from 'react';
import { Box } from 'grommet';

// Helpers and utilities
// import { breakpointSize } from '@theme/globals/sizing';
import { pxToRem } from '@theme/utils/sizing';
import { convertPropToSize } from '@theme/utils/sizing';

import { breakpoints } from '@theme/globals/breakpoints';

// Types
import type { SHDContainerProps } from './SHDContainer.d';
import type { BreakpointSizeType } from '@theme/theme.d';
import type {
  EdgeType as GrommetEdgeType,
  GapType as GrommetGapType,
  PadType as GrommetPadType,
} from 'grommet/utils';

const SHDContainer: React.FC<SHDContainerProps> = ({
  alignContent = 'stretch',
  alignSelf = 'stretch',
  background = 'white',
  children,
  className = 'container',
  gap = 'none',
  margin = { horizontal: 'auto', vertical: '0' },
  maxWidth = 'xlarge',
  overflow = { horizontal: 'hidden', vertical: 'auto' },
  pad = 'small',
  parentRef,
  ...props
}) => {
  const getMaxWidth = (maxWidthPropValue: string) => {
    if (maxWidthPropValue === 'none') {
      return 'none';
    }

    return pxToRem(breakpoints[maxWidthPropValue as BreakpointSizeType].value);
  };

  return (
    <Box
      ref={parentRef}
      alignContent={alignContent}
      alignSelf={alignSelf}
      as="main"
      background={background}
      className={className}
      direction="column"
      flex={true}
      focusIndicator={false}
      height={{ min: '100dvh' }}
      gap={convertPropToSize<
        GrommetGapType | { row?: GrommetGapType; column?: GrommetGapType }
      >(gap)}
      margin={convertPropToSize<GrommetEdgeType>(margin)}
      overflow={overflow}
      pad={convertPropToSize<GrommetPadType>(pad)}
      responsive={true}
      width={{ width: '100%', max: getMaxWidth(maxWidth) }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default SHDContainer;
